// extracted by mini-css-extract-plugin
export var cardTitle = "_cl-1";
export var commentBubble = "_cl-e";
export var commentForm = "_cl-a";
export var commentInput = "_cl-b";
export var commentLabel = "_cl-d";
export var commentPrompt = "_cl-9";
export var csatCard = "_cl-0";
export var feedbackSection = "_cl-7";
export var starDisabled = "_cl-6";
export var starEmpty = "_cl-5";
export var starFilled = "_cl-4";
export var starWrapper = "_cl-3";
export var starsContainer = "_cl-2";
export var submittedComment = "_cl-c";
export var thankYouText = "_cl-8";